import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd049aService,
  Sgkd049aRequest,
  Sgkd049aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd020dSgkd049aService {

  private _rsesult$ = new Subject<Sgkd049aResponse>();

  constructor(
    private sgkd049aService: Sgkd049aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   *  SGKD049A_口振・クレ申込受付取得API呼び出し
   * 
   * @param payMethod 支払方法
   * @param firstSrvctrNo 契約お客さま番号
   * @param recptFixNo 支払契約番号
   * @returns 
   */
  doSgkd049a(payMethod: string, firstSrvctrNo: string, recptFixNo: string): Observable<Sgkd049aResponse> {
    // リクエスト生成
    let request: Sgkd049aRequest = {
      requestDto: {
        /** 契約お客さま番号 */
        firstSrvctrNo: firstSrvctrNo,
        /** 請求お客さま番号 */
        recptFixNo: recptFixNo,       
        /** 支払方法コード */
        payMthdiv: payMethod
      }
    }
    
    return this.sgkd049aService.doSGKD049APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD049A');
          return throwError(err.message);
        }
        )
      );
  }
}
